import { render, staticRenderFns } from "./EmailSettings.vue?vue&type=template&id=62f72206"
import script from "./EmailSettings.vue?vue&type=script&lang=ts"
export * from "./EmailSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports